import React from 'react';
import Shimmer from '../../common/Shimmer';

const PendingOrdersCardShimmer: React.FC = () => {
  return (
    <div className="pending-orders-card shimmer-card">
      <div className="pending-orders-header">
        <div className="pending-orders-title">
          <Shimmer width="18px" height="18px" borderRadius="50%" />
          <Shimmer width="180px" height="20px" />
        </div>
        <Shimmer width="120px" height="36px" className="shimmer-button" />
      </div>

      <div className="pending-orders-subtitle">
        <Shimmer width="100%" height="32px" />
      </div>

      <div className="pending-orders-summary">
        <Shimmer width="150px" height="24px" className="shimmer-title" />
        
        <div className="summary-details">
          <div className="summary-metrics">
            <div className="metric-item">
              <Shimmer width="80px" height="14px" className="shimmer-text" />
              <Shimmer width="60px" height="18px" className="shimmer-text" />
            </div>
            
            <div className="metric-item">
              <Shimmer width="100px" height="14px" className="shimmer-text" />
              <Shimmer width="120px" height="18px" className="shimmer-text" />
            </div>
          </div>

          <div className="key-accounts">
            <Shimmer width="19px" height="19px" borderRadius="50%" />
            <Shimmer width="100px" height="16px" />
          </div>
        </div>
      </div>

      <div className="pending-orders-footer">
        <Shimmer width="100px" height="16px" />
      </div>
    </div>
  );
};

export default PendingOrdersCardShimmer;
